import React, { useEffect, useState } from 'react';
import api from '../../seller-apis/api'
import '../CustomerLeads/Leads.css';
import { Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TransactionTabs from './TransactionTabs';
import TransactionDetails from './TransactionDetails';
import BackendTransactions from './BackendTransaction';
import DailyReport from './DailyReport';


function WalletTrasaction(props) {
    const { path, url } = useRouteMatch();
    const stateData = useSelector((state) => state);
    
    return (
        <>
            <div className=''>

             {/* <TransactionTabs /> */}
                
            </div>
            <div>
                <Route exact path="/wallet-transaction">
                    <Redirect to={`${path}/daily-report`} />
                </Route>
                <Route path={`${path}/daily-report`} component={DailyReport} />
                <Route path={`${path}/vendor-transaction`} component={TransactionDetails} />
                <Route path={`${path}/tv-transaction`} component={BackendTransactions} />
                
            </div>
        </>
    )




}


export default WalletTrasaction;